import { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchLoginUserReportCard from "../../../components/card/SearchLoginUserReportCard";
import LoginUserReportTable from "../../../components/table/LoginUserReportTable";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import { ExportLoginUsersReportForExcelPDFBody } from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const LoginUserReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportLoginUsersReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allUsers, setAllUsers] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("loginUserReport")}
        </h1>
      </BackButtonWrapper>

      <SearchLoginUserReportCard
        setAllUsers={setAllUsers}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <LoginUserReportTable
        allUsers={allUsers}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default LoginUserReport;
